module.exports = __webpack_public_path__ + "7e436228d3b16983fa7eb1109b35740c.pdf";